<script setup>
import {ref,onMounted} from "vue";

const data = ref(10)
onMounted(()=>{
    console.log("Affichage sur la vue");
});
</script>
<template>
    <div class="w-full p-[16px]">
        <span>{{ data }}</span>
    </div>
</template>